<ds-filter
  class="ds-mt-6"
  [filterItems]="filterItems"
  [actionButtons]="actionButtons"
  (searchChange)="onSearchChange($event)"
  (filtersChange)="onFiltersChange($event)"
/>

<ng-template #consolidateDialog let-data>
  <p>
    {{ translation.dialogConsolidateIstatIntro(data.month, data.year) }}
  </p>
  @if (data) {
    <ul>
      @for (item of buildConsolidateIstatSummary(data); track item.label) {
        <li>{{ item.label }}: {{ item.value }}</li>
      }
    </ul>
  }
  <br />
  <div>{{ translation.dialogConsolidateIstatQuestion }}</div>
</ng-template>
